import { useReceiptStore } from "@elixir/stores";
import { PopupWrapper, ReceiptRowUi, TableUi } from "ui";
import { RECEIPT_FLOW_STATES } from "@elixir/types";
import {
  createNewReceipt,
  viewReceipt,
  editReceipt,
  closeReceiptPopupEvent,
} from "../../utils/receipt";
import ReceiptInputParams from "./input-fields/receipt-input-params";
import { Modal, notification } from "antd";
import useDeleteReceipt from "../../apis/tryst/use-delete-receipt";
import getB from "../../utils/bridges/EkaBridge";
import queryClient from "../../instances/react-query-client";
import { getAllQueuesQuery } from "../../apis/tryst/get-all-queues";
import { getPatientDetails } from "../../utils/bridges/methods";

export default function ViewAllReceipts() {
  const receiptState = useReceiptStore((state) => state.receiptState);
  const onReceiptPopupClose = useReceiptStore(
    (state) => state.setCloseReceiptPopup
  );

  const selectedAppointment = useReceiptStore(
    (state) => state.selectedAppointment
  );
  const setSelectedAppointment = useReceiptStore(
    (state) => state.setSelectedAppointment
  );

  const { mutateAsync: deleteArchiveReceipt } = useDeleteReceipt();

  return (
    <PopupWrapper
      title="View All Receipts"
      open={receiptState === RECEIPT_FLOW_STATES.VIEW_ALL_RECEIPTS}
      onClose={() => {
        onReceiptPopupClose();
        closeReceiptPopupEvent();
      }}
      style={{ height: "75vh" }}
      onOk={() => {
        createNewReceipt({ appointment: selectedAppointment });
      }}
      okText="Create New Receipt"
      cancelText={"Close"}
      OkButtonIcon={() => <></>}
    >
      <div className="dr-flex dr-flex-col dr-h-full dr-overflow-auto">
        <ReceiptInputParams disableName disablePhone hidePaymentStatus />
        <TableUi
          headersConfig={[
            { width: "12%", headerName: "S No." },
            { width: "20%", headerName: "Service" },
            { width: "15%", headerName: "Status" },
            { width: "20%", headerName: "Created At" },
            { width: "18%", headerName: "Total Amount" },
            { width: "25%", headerName: "Actions" },
          ]}
        >
          {selectedAppointment?.receipts?.map((item, idx) => (
            <ReceiptRowUi
              key={item.receipt_id}
              receipt={item}
              sNo={idx + 1}
              onViewReceipt={() => {
                viewReceipt({ receipt: item });
              }}
              onEditReceipt={() => {
                editReceipt({
                  appointment: selectedAppointment,
                  receiptId: item.receipt_id,
                });
              }}
              onDeleteReceipt={() => {
                Modal.confirm({
                  title: "Are you sure you want to delete the receipt?",
                  content: item.amount_due
                    ? `This Receipt has a due of ₹${item.amount_due}. ${
                        selectedAppointment?.patient?.fn
                      }'s current outstanding due is ₹${
                        selectedAppointment?.patient?.amount_pending || 0
                      }. After receipt is deleted, outstanding due amount would be ₹${Math.max(
                        (selectedAppointment?.patient?.amount_pending || 0) -
                          item.amount_due,
                        0
                      )}`
                    : undefined,
                  okText: "Yes",
                  onOk: async () => {
                    const patientOid = selectedAppointment?.patient_oid || selectedAppointment?.patient?.oid;
                    let abhaId: string | undefined;
                    if (patientOid) {
                      const patients = await getPatientDetails({ patientOids: [patientOid] });
                      abhaId = patients?.[0]?.patient?.abha?.id;
                    }
                    const { success } = await deleteArchiveReceipt({
                      receiptId: item.receipt_id,
                      patientOid,
                      abhaId,
                    });

                    if (success) {
                      notification.success({
                        message: "Deleted Receipt Successfully",
                        placement: "bottomRight",
                      });

                      const updatedReceipts =
                        selectedAppointment?.receipts?.filter(
                          (receipt) => item.receipt_id !== receipt.receipt_id
                        );

                      await new Promise((resolve) => setTimeout(resolve, 1000));
                      const bridge = await getB();
                      await bridge.fetchPatientListFromServer([
                        selectedAppointment?.patient_oid ||
                          selectedAppointment?.patient?.oid,
                      ]);
                      queryClient.invalidateQueries(getAllQueuesQuery({}));
                      if (updatedReceipts.length) {
                        setSelectedAppointment({
                          ...selectedAppointment,
                          receipts: updatedReceipts,
                        });
                      } else {
                        onReceiptPopupClose();
                      }
                    } else {
                      notification.error({
                        message: "Failed to Delete Receipt",
                        placement: "bottomRight",
                      });
                    }
                  },
                });
              }}
            />
          ))}
        </TableUi>
        <div className="dr-py-24"></div>
      </div>
    </PopupWrapper>
  );
}
